import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { BrandsPanel } from '~/components/routes/categories/BrandsPanel'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'
import { CATEGORIES_TAB_PERMISSIONS } from '~/components/routes/categories/tabs'

export const Route = createFileRoute('/_authenticated/categories/brands')({
  staticData: {
    permission: CATEGORIES_TAB_PERMISSIONS.brands,
  },
  component: BrandsTabPage,
})
withRoutePermissions(Route)

function BrandsTabPage() {
  return (
    <CategoriesPageLayout
      activeTab="brands"
      actions={
        <AuthorizedButtonLink
          variant="contained"
          sx={{ marginRight: '16px' }}
          to="/categories/brand/new"
        >
          <PlusIcon />
          Ajouter une marque
        </AuthorizedButtonLink>
      }
    >
      <BrandsPanel />
    </CategoriesPageLayout>
  )
}
